var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-facts-form',{attrs:{"next-step-path":"PartnerPortal-ReportDamage-DocumentUpload","previous-step-path":"PartnerPortal-ReportDamage-Info","is-broker":true}})}
var staticRenderFns = []

export { render, staticRenderFns }